import "../../../../content/projects/dobroed/dobroed.css";
import * as React from 'react';
export default {
  React
};